import { w as withConfigTransport } from "../../services/config-transport/withConfigTransport.js";
import { V as VaButton$1 } from "./VaButton.js";
const VaButton = withConfigTransport(VaButton$1);
export { VaButton as V };
//# sourceMappingURL=index.js.map
